import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MatrixAccordionItem from './MatrixAccordionItem';
import getUnchangedTrip from '../helpers/getUnchangedTrip';
import './matrix-accordion.styles.scss';
import { airportItemShape } from '../../../SearchResult/flight/shapes';

const WINDOW_SIZE_FOR_MOBILE_VIEW = 991;

const MatrixAccordion = ({
  trips,
  activeTripId,
  activeTabKey,
  setActiveStepIndex,
  fetchAirportDetails,
  airports,
  airlineInformations,
  fetchAirlineInformations,
  windowWidth,
  pastJourneyElementTrips,
  canExchange,
}) => {
  const totalPastJourneyElementTrips = pastJourneyElementTrips.length;
  const isPartialExchange = totalPastJourneyElementTrips > trips.length;
  const unchangedTrip = getUnchangedTrip(canExchange, trips, pastJourneyElementTrips);
  const combinedTrips = unchangedTrip ? [...trips, unchangedTrip] : trips;

  return (
    <ul className="matrix-accordion">
      {combinedTrips.map((trip, index) => (
        <Fragment key={trip.id}>
          <MatrixAccordionItem
            trip={trip}
            windowWidth={windowWidth}
            isOpened={
              (activeTabKey !== 'all' && trip.id === activeTripId) || activeTabKey === 'all'
            }
            setActiveStepIndex={activeTabKey === 'all' ? () => {} : setActiveStepIndex}
            fetchAirportDetails={fetchAirportDetails}
            airports={airports}
            airlineInformations={airlineInformations}
            fetchAirlineInformations={fetchAirlineInformations}
            canExchange={canExchange}
            isChanged={trip.id !== unchangedTrip?.id}
            isPartialExchange={isPartialExchange}
          />
          {windowWidth > WINDOW_SIZE_FOR_MOBILE_VIEW && index < combinedTrips.length - 1 && (
            <div className="matrix-accordion__divider" />
          )}
        </Fragment>
      ))}
    </ul>
  );
};

MatrixAccordion.defaultProps = {
  pastJourneyElementTrips: [],
};

MatrixAccordion.propTypes = {
  trips: PropTypes.arrayOf(PropTypes.shape({ originCode: PropTypes.string })).isRequired,
  activeTripId: PropTypes.number.isRequired,
  activeTabKey: PropTypes.string.isRequired,
  setActiveStepIndex: PropTypes.func.isRequired,
  fetchAirportDetails: PropTypes.func.isRequired,
  airports: PropTypes.shape(airportItemShape).isRequired,
  airlineInformations: PropTypes.shape({}).isRequired,
  fetchAirlineInformations: PropTypes.func.isRequired,
  windowWidth: PropTypes.number.isRequired,
  pastJourneyElementTrips: PropTypes.arrayOf(
    PropTypes.shape({
      originCode: PropTypes.string.isRequired,
      destinationCode: PropTypes.string.isRequired,
      durationInMinutes: PropTypes.number,
      startsAtInUserTz: PropTypes.string,
      endsAtInUserTz: PropTypes.string,
      segments: PropTypes.arrayOf(
        PropTypes.shape({
          marketingAirlineInfo: PropTypes.shape({
            code: PropTypes.string,
          }),
          operatingFlight: PropTypes.string,
        }),
      ),
    }),
  ),
  canExchange: PropTypes.bool.isRequired,
};

export default MatrixAccordion;
